import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import styled from '@emotion/styled'

import { IconList3, Link, LINK_VARIANT_EXTRALIGHT } from 'mailup-web-components'

import { openModalListFilterCallback } from 'Pages/ScheduledSendings/recoil/callbacks/callbacks'
import { calendarState } from 'Pages/ScheduledSendings/recoil/state/calendar'
import { singleListFilterState } from 'Pages/ScheduledSendings/recoil/state/listFilter'

const StyledIcon = styled(IconList3)`
  font-size: 14px;
  color: var(--boulder);
  margin-right: 8px;
`

const ListFilter = () => {
  const intl = useIntl()
  const { lists } = useRecoilValue(calendarState)
  const singleListFilter = useRecoilValue(singleListFilterState)
  const openModal = useRecoilCallback(openModalListFilterCallback, [])

  return (
    <>
      <StyledIcon />
      <Link variant={LINK_VARIANT_EXTRALIGHT} onClick={openModal}>
        {lists.length === 0 ? (
          intl.formatMessage({ id: 'Load.ScheduledMailing.AllLists' })
        ) : lists.length === 1 ? (
          <>
            {intl.formatMessage({ id: 'Load.ScheduledMailing.SelectedList' })}
            {': '}
            {singleListFilter.label}
          </>
        ) : (
          <>
            {intl.formatMessage({
              id: 'Load.ScheduledMailing.OnlySelectedLists'
            })}{' '}
            ({lists.join(',')})
          </>
        )}
      </Link>
    </>
  )
}

export default ListFilter
